/**
 * Check if PlayCanvas iframe is ready for API calls.
 * Returns true when both the containerRef exists and the ready flag is set.
 */
export function isPlayCanvasReady(): boolean {
    //@ts-ignore
    return !!(window.containerRef?.current?.contentWindow && window.playCanvasReady);
} 